module.exports = __webpack_public_path__ + "static/media/pushbutton.6a1fc787.jpg";